import Game from "pages/Game";
import Info from "pages/Info";
import {
	createBrowserRouter
} from "react-router-dom";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Game />,
	}, {
		path: "/info",
		element: <Info />,
	},
]);

export default router;